"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  fragment FaqModule on EditorialFrequentlyAskedQuestions {\n    __typename\n    id\n    questions {\n      __typename\n      title\n      content {\n        __typename\n        text\n        textLinks {\n          relativeUrl\n          title\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.faqModuleFragment = void 0;
var _fetching = require("@ori/fetching");
const faqModuleFragment = exports.faqModuleFragment = (0, _fetching.gql)(_templateObject());
